import { GenericObject } from "@/types";
import { DtoCubeDataResponse } from "@/types/dto-types";
import { Attribute } from "./components/AttributeFilters/types";
import { CubeSideName } from "./FuturebilityCockpit/components/Сube/types";
import { CubeSideData } from "./FuturebilityCockpit/hooks/useCategoryPageData/types";

export const filterEntries = (
  entries: GenericObject[],
  attributes: GenericObject<Attribute>
) => {
  const attributesKeys = Object.keys(attributes);

  if (!attributesKeys.length) {
    return entries;
  }

  return entries.filter(entry => {
    return attributesKeys.every(attrKey => {
      const attribute = attributes[attrKey];
      return attribute.options.some(
        attrOption => entry[attrKey] === attrOption
      );
    });
  });
};

export const decodeStringNumberToValuesArray = (num: string) => {
  const selectedValues: any[] = [];
  const binString = parseInt(num, 10).toString(2);

  const allValues = binString.split("").reverse();
  allValues.forEach((v, index) => {
    if (v === "1") {
      selectedValues.push(index);
    }
  });

  return selectedValues;
};

export const getTestSetColorsByCubeSide = (rawData?: DtoCubeDataResponse) => {
  return rawData?.testSets.reduce((acc, testSet) => {
    acc[testSet.info.cubeSide as CubeSideName] =
      // @ts-ignore
      testSet.info?.color || "#FFFFFF";
    return acc;
  }, {} as Record<CubeSideName, string>);
};

export const getTestSetTitlesByCubeSide = (
  cubeSidesData: Record<CubeSideName, CubeSideData>
): Record<CubeSideName, string> =>
  Object.fromEntries(
    Object.entries(cubeSidesData).map(([key, value]) => [key, value.title])
  ) as Record<CubeSideName, string>;

export const getCubeColor = (
  key: CubeSideName,
  colorMap: Record<CubeSideName, string> | undefined
) => colorMap?.[key] || "#FFFFFF";
